import { REDUCER_NAME } from './const'
import * as R from 'ramda'

export const selectOwnState = (state) => {
    return state[REDUCER_NAME]
}


export const selectLeadList = (state) => {
    return selectOwnState(state).leadList
}

export const selectLeadById = (state, leadId) => {
    const leadList = selectLeadList(state)
    return R.find(R.propEq('id', leadId))(leadList)
}

export const selectLead = state => {
    return selectOwnState(state).lead
}

export const selectIsFetching = state => {
    return selectOwnState(state).fetching
}

export const selectHasChanged = state => {
    return selectOwnState(state).hasChanged
}



// WEBPACK FOOTER //
// ./src/modules/lead/state/selector.js